module.exports = __webpack_public_path__ + "75e7a1c71948d276f91a27d985353c08.svg";